import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const planReportPageRoute: InvariantJiraRoute = {
	name: 'software-advanced-roadmaps',
	path: '/jira/plans/reports/:reportId',
};
